// extracted by mini-css-extract-plugin
module.exports = {"announcement":"style_announcement__f6ImO","dismiss":"style_dismiss__n5SFo","marquee":"style_marquee__B22yL","scroll":"style_scroll__U0kIq"};